export default {"src":"/_next/static/media/flag-turkiye.d0b66478.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};